import { TIMEZONES } from 'shared/mui/DatePicker/constants/timezones';
import { formatInputInTz } from 'utils/date';

const DATE_FORMAT = 'dd.MM.yyyy HH:mm';

type GetReportPeriodParams = {
  dateGte?: number | null;
  dateLte?: number | null;
  timezone?: string | null;
  withTimezone?: boolean;
};

export const getReportPeriod = ({
  dateGte,
  dateLte,
  timezone,
  withTimezone = true,
}: GetReportPeriodParams): string => {
  const startDate = dateGte ? formatInputInTz(dateGte, { timezone, format: DATE_FORMAT }) : '';

  const endDate = dateLte ? formatInputInTz(dateLte, { timezone, format: DATE_FORMAT }) : '';

  const period = `${startDate} - ${endDate}`;

  if (!withTimezone) {
    return period;
  }

  const currentTimezone = TIMEZONES.find((tz) => tz?.name === timezone)?.offset || '+3 UTC';

  return `${period} (${currentTimezone})`;
};
